export class HorseDetailsTrailer {
            id: string = '';
            horse_detail_id: string = '';
            chasis_number: string = '';
            brand: string = '';
            sum_insured: number = null;
            manufactured_year: string = '';
            purchase_date: string = '';
}
